// navigateHelper.js
let navigate;

export const setNavigate = (nav) => {
  navigate = nav;
};

export const getNavigate = () => navigate;
